// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg[data-v-0fa64365]{background-color:#fff}.h-128[data-v-0fa64365]{height:32rem}.h-144[data-v-0fa64365]{height:48rem}", ""]);
